// #/utils/stringifyJson.ts
import superjson from 'superjson';

import { logger } from '#/logger';

// const bigintReplacer = (key, value) =>
//   typeof value === 'bigint' ? value.toString() : value; // return everything else unchanged

export function parseJson<T>(value: string) {
  try {
    return superjson.parse<T>(value);
  } catch (error: any) {
    logger.error(error);
    logger.error(`value: ${value}`);
    try {
      return JSON.parse(value);
    } catch (error: any) {
      logger.error(error);
      logger.error(`value: ${value}`);
      return value;
    }
  }
}
